import React from 'react';

export const GameIcon = ({ color }) => (
  <svg
    height="22px"
    version="1.1"
    viewBox="0 0 32 32"
    width="22px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      id="Page-1"
      stroke={color || '#000000'}
      strokeWidth="1"
    >
      <g fill={color || '#000000'} id="icon-1-basketball">
        <path
          d="M17,5.01067418 C19.8101545,5.1308899 22.3590972,6.25958557 24.2941063,8.04403932 L24.2941063,8.04403932 C22.3537641,10.1553555 21.1303481,12.9359954 21.0098172,16 L17,16 L17,5.01067418 L17,5.01067418 Z M16,5.01067418 C13.1898455,5.1308899 10.6409028,6.25958557 8.7058937,8.04403932 L8.70589371,8.04403932 C10.6462359,10.1553555 11.8696519,12.9359954 11.9901828,16 L16,16 L16,5.01067418 L16,5.01067418 Z M17,27.9893258 C19.8101545,27.8691101 22.3590972,26.7404144 24.2941063,24.9559607 L24.2941063,24.9559607 C22.3537641,22.8446445 21.1303481,20.0640046 21.0098172,17 L17,17 L17,27.9893258 L17,27.9893258 Z M16,27.9893258 C13.1898455,27.8691101 10.6409028,26.7404144 8.70589371,24.9559607 C10.6462359,22.8446445 11.8696519,20.0640046 11.9901828,17 L16,17 L16,27.9893258 L16,27.9893258 Z M25,8.75391932 C26.7589727,10.682986 27.8701021,13.2130336 27.9893258,16 L27.9893258,16 L22.0106742,16 C22.1298979,13.2130336 23.2410273,10.682986 25,8.75391932 L25,8.75391932 L25,8.75391932 Z M25,24.2460807 C26.7589727,22.317014 27.8701021,19.7869664 27.9893258,17 L27.9893258,17 L22.0106742,17 C22.1298979,19.7869664 23.2410273,22.317014 25,24.2460807 L25,24.2460807 L25,24.2460807 Z M5.01067418,16 C5.12989794,13.2130336 6.24102729,10.682986 8,8.75391932 L8,8.75391932 C9.75897271,10.682986 10.8701021,13.2130336 10.9893258,16 L5.01067418,16 L5.01067418,16 Z M5.01067418,17 C5.12989794,19.7869664 6.24102729,22.317014 8,24.2460807 C9.75897271,22.317014 10.8701021,19.7869664 10.9893258,17 L5.01067418,17 L5.01067418,17 Z M16.5,29 C23.4035597,29 29,23.4035597 29,16.5 C29,9.59644029 23.4035597,4 16.5,4 C9.59644029,4 4,9.59644029 4,16.5 C4,23.4035597 9.59644029,29 16.5,29 L16.5,29 Z"
          id="basketball"
        />
      </g>
    </g>
  </svg>
);
